import type { InvestmentRecord } from "../types/domain";
import { dataAgeStatus } from "./calculations";

export const warningsForRecord = (record: InvestmentRecord, now = new Date()) => {
  const warnings: string[] = [];
  if (record.price.dataStatus === "sample") warnings.push("Sample data: not live and not investment advice.");
  if (dataAgeStatus(record.price.priceDate, 7, now) === "stale") warnings.push("Price data is older than seven days.");
  const latestFinancial = record.financials[0];
  if (!latestFinancial) warnings.push("No approved financial period is available.");
  if (latestFinancial?.periodType === "quarterly" && dataAgeStatus(latestFinancial.periodEndDate, 183, now) === "stale") {
    warnings.push("Quarterly data is older than six months.");
  }
  if (record.recommendation.unresolvedCriticalWarning) warnings.push("Critical validation warning is unresolved.");
  if (record.valuation.dataStatus === "sample") warnings.push("Valuation assumptions are sample data.");
  return warnings;
};
